<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
    <dl v-if="productData" class="mb-0">
      <div class="row">
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Marca</div>
          <dd>{{ productData.brand }}</dd>
        </div>
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Modelo</div>
          <dd>{{ productData.model }}</dd>
        </div>
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Color</div>
          <dd>{{ productData.color }}</dd>
        </div>
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Stock</div>
          <dd>{{ productData.stock }}</dd>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Capacidad</div>
          <dd>{{ productData.capacity }}</dd>
        </div>
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Nº Cuotas</div>
          <dd>{{ productData.prices.payment.fees }}</dd>
        </div>
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Cuota</div>
          <dd>{{ productData.prices.payment.totalFee }}€</dd>
        </div>
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Total</div>
          <dd>{{ productData.prices.payment.totalFee * productData.prices.payment.fees }}€</dd>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">EAN</div>
          <dd>{{ productData.merchantData.ean }}</dd>
        </div>
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Proveedor</div>
          <dd>{{ productData.merchantData.merchant }}</dd>
        </div>
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Franquicia reparación</div>
          <dd>{{ productData.prices.policy.repairExcess }}€</dd>
        </div>
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Franquicia reemplazo</div>
          <dd>{{ productData.prices.policy.replacementExcess }}€</dd>
        </div>
      </div>
    </dl>
    <div class="botonNewContract float-right" v-if="productData.stock > 0">
      <button type="button" class="btn btn-primary generalPrimaryButton mb-2" @click="iniciarContrato()"
        data-dismiss="modal">INICIAR
        CONTRATO</button>
    </div>
  </Modal>
</template>

<script>

import Modal from '../../../Shared/Modal.vue';
import axios from 'axios';
export default {
  name: 'ProductDetail',
  props: [
    'id',
    'modalTitle',
    'class',
    'productEan'
  ],
  data() {
    return {
      classes: this.class,
      productData: '',
    };
  },
  updated() {
    this.loadProductData();
  },
  components: {
    Modal,
  },
  methods: {
    loadProductData() {
      axios.get(`/products/get-by-ean/${this.productEan}`)
        .then((response) => {
          this.productData = response.data;
        });
    },
    iniciarContrato() {
      this.$store.commit('RESET_STATE_CONTRACTS');
      if (!this.$store.state.roles.Backoffice_member_empresas) {        
        axios.get(`/products/get-by-ean/${this.productEan}`)
          .then((response) => {
            const bodyToSave = {
              id: response.data.id,
              supplier: response.data.merchantData.merchant,
              brand: response.data.brand,
              model: response.data.model,
              capacity: response.data.capacity,
              ean: response.data.merchantData.ean,
              color: response.data.color,
              price: response.data.prices.payment.totalFee * response.data.prices.payment.fees,
              nQuotas: response.data.prices.payment.fees,
              quotaPrice: response.data.prices.payment.totalFee,
              stock: response.data.stock,
            }
  
            this.$store.commit('setNewContractDataProduct', bodyToSave);
            this.$router.push({ name: 'newContractStep2' })
          });
      }else{
        this.$router.push({ name: 'newContractStep1' })
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.botonNewContract {
  text-align: center;
}
</style>
